module.exports = __webpack_public_path__ + "static/media/forget-password-illustration.bec0c437.svg";